import classNames from 'classnames/bind';
import { i18nKeys, useTranslation } from 'locales';
import type { LightThirdPartyCase } from 'modules/ThirdpartyCases/api';
import styleIdentifiers from './tpCaseStatusItem.module.scss';

const styles = classNames.bind(styleIdentifiers);

type TpCaseStatusItemProps = {
  className?: string;
  caseDetail: LightThirdPartyCase;
};

export default function TpCaseStatusItem({ className, caseDetail }: TpCaseStatusItemProps) {
  const { t } = useTranslation();

  const status = getStatus(caseDetail);

  const availableStatus = {
    notOpen: {
      step: 1,
      text: t(i18nKeys.THIRD_PARTY_CASES.NOT_STARTED),
    },
    open: {
      step: 2,
      text: t(i18nKeys.THIRD_PARTY_CASES.STARTED),
    },
    close: {
      step: 3,
      text: t(i18nKeys.THIRD_PARTY_CASES.CLOSED),
    },
  };
  const { step } = availableStatus[status];

  return (
    <div className={styles('tp-case-status-item', `step-${step + 1}`, className)}>
      <div className={styles('label')}>{availableStatus[status].text}</div>
      <div className={styles('indicator')}>
        {new Array(3).fill(0).map((_, key) => (
          <span key={key} className={styles('indic', key <= step - 1 && 'selected')} />
        ))}
      </div>
    </div>
  );
}

const getStatus = (caseDetail: { closed: boolean; started: boolean }) => {
  if (caseDetail.closed) return 'close';
  if (caseDetail.started) return 'open';
  return 'notOpen';
};
